import styled from 'styled-components';
import Head from './Head';
import Courses from './Courses';
import Teachers from './Teachers';
import Workshops from './Workshops';
import { UpcomingEvents } from './UpcomingEvents';
import { SectionHeader, Separator } from '../../components/SectionHeader';
import { Hero } from '../../components/Hero';
import { Footer } from '../../components/Footer';
import { ButtonTeamup } from '../../components/Menu/ButtonTeamup';

import heart from './assets/heart.svg';
import hero from './assets/improcampa_25.jpeg';

// @ts-ignore
interface SchoolProps {
}

const SchoolContainer = styled.div`
`;

const Content = styled.div`
  position: relative;
  top: 100vh;
  padding: calc(-1.875vw + 36px); /* 1920: 0, 320: 30 */
  padding-bottom: 200px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const ButtonTeamupStyled = styled(ButtonTeamup)`
  margin-top: 1em;
`;

const Description = styled.p`
  font-family: League Spartan;
  font-style: normal;
  font-weight: bold;
  font-size: calc(0.125vw + 17.6px); /* 1920: 20, 320: 18 */
  line-height: 1.5em;
  text-align: center;
  color: #f0f0f0;
  margin-bottom: 5em;
`;

const Flag = styled.img`
  position: absolute;
  top: 12px;
  right: 12px;
`;

const Notice = styled.p`
  font-family: League Spartan;
  font-weight: bold;
  font-size: 14px;

  /* white */
  color: #FFFFFF;
`;

const WishlistExplainer = styled.div`
  color: ${({ theme }) => theme.palette.yellowSchool};
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 2em;
  padding: 0px calc(8.75vw + -28px); /* 1920: 140, 320: 0 */

  @media (max-width: 630px) {
    flex-direction: column;
    text-align: center;
  }
`;

const Heart = styled.img`
  margin: 0 1em 0 0;

  @media (max-width: 630px) {
    margin: 0 0 1em 0;
  }
`;

function School(_: SchoolProps) {
  return (
    <SchoolContainer>
      <Head />
      <Hero
        title='Aprende en esimpro escuela'
        image={{
          src: hero,
          alt: 'Comunidad de la Improescuela',
          opacity: 0.7,
        }}
      />
      <Content>
        <Description>
          Aprende en nuestros cursos regulares y talleres, improvisación y teatro, en español.<br />
          Learn in our regular courses and workshops, improvisation and acting, in English.
        </Description>
        <SectionHeader
          title='Agenda'
          description='Aquí tienes todo lo programado'
          variant='yellow'
        />
        <ButtonTeamupStyled />
        <Separator />
        <UpcomingEvents />
        <SectionHeader
          title='Clases regulares'
          description='Elije tu curso y tu tipo de abono'
          separator
          variant='yellow'
        />
        <Courses />
        <Notice>*los horarios pueden cambiar</Notice>
        <Separator style={{ marginBottom: '1em' }}/>
        <SectionHeader
          title='Todos los workshops'
          description='Intensivos, voz, cuerpo, mente, interpretación... ¿Cuál es el tuyo?'
          separator
          variant='yellow'
        />
        <WishlistExplainer>
          <Heart src={heart} alt='Icono de corazón' />
          Si te interesa algún curso, toca su corazón e intentaremos programarlo
        </WishlistExplainer>
        <Workshops />
        <SectionHeader
          title='Equipo'
          description='Cuando no improvisan, enseñan'
          separator
          variant='yellow'
        />
        <Teachers />
        <Footer />
      </Content>
    </SchoolContainer>
  );
}

export { School };
